import { gql } from '@apollo/client';

// 卸车 tab 顶部计数汇总：已卸运单数量 + 应卸容器数量（随卸车 tab 请求一并返回）
export const GET_UNLOADING_COUNT_SUMMARY = gql`
    query GetUnloadingCountSummary($taskId: Long!, $taskWaypointId: Long!) {
        getUnloadingCountSummary(taskId: $taskId, taskWaypointId: $taskWaypointId) {
            parcelCount
            expectedContainerCount
        }
    }
`;

export interface GetUnloadingCountSummaryResponse {
    getUnloadingCountSummary: {
        parcelCount: number;
        expectedContainerCount: number;
    };
}

export interface GetUnloadingCountSummaryVariables {
    taskId: number;
    taskWaypointId: number;
}
